import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslations } from "@jti/ui";
import styles from "./ResetEmailSent.module.scss";
const ResetEmailSent = () => {
    const { __ } = useTranslations();
    return (_jsxs("div", { className: styles.container, children: [_jsx("span", { className: styles.title, children: __("reset_password.mail_sent.title") }), _jsx("p", { className: styles.text, children: __("reset_password.mail_sent.message") }), _jsx("p", { className: styles.text, children: __("reset_password.mail_sent.message.spam") })] }));
};
export default memo(ResetEmailSent);
